import apiClient from "./axios"

const BASE_URL = "/key-types"

// Get all key types
export const getKeyTypes = async (params = {}) => {
  const { data } = await apiClient.get(BASE_URL, { params })
  return data
}

// Get a single key type
export const getKeyType = async (id) => {
  const { data } = await apiClient.get(`${BASE_URL}/${id}`)
  return data
}

// Create a key type
export const createKeyType = async (payload) => {
  const { data } = await apiClient.post(BASE_URL, payload)
  return data
}

// Update a key type
export const editKeyType = async ({ id, ...payload }) => {
  const { data } = await apiClient.put(`${BASE_URL}/${id}`, payload)
  return data
}

// Delete a key type
export const deleteKeyType = async (id) => {
  const { data } = await apiClient.delete(`${BASE_URL}/${id}`)
  return data
}
